import { useState, useEffect } from 'react';
import { Tabs } from '../../tailwindcomponents';
import toolApi from '../../api/tools';
import taskApi from '../../api/tasks';
import lineApi from '../../api/line';
import certificatesApi from '../../api/certificates';
import { MyLineTask } from '../../types/tasks';
import { CertificateData } from '../../types/certificates'
import { LoanedToolsForMe } from '../../types/tool';
import { FlightSchedule } from '../../types/line';
import { MxiStaffManagementEmployee } from './../../types/staffManagement';
import MyTaskPlan from './MyTaskPlan';
import MyTools from './MyTools';
import MyCertificates from './MyCertificates';
import MyFlightSchedule from './MyFlightSchedule';
import { RootState } from '../../reducer';
import { useSelector } from 'react-redux';
import LineTasks from './LineTasks';
import staffmanagementApi from '../../api/staffmanagement';
import { useQueryTab } from '../../utils/usePersistedTab';
import TeamsPage from './Teams/TeamsPage';

const MyProfilePage = () => {

    const { tabValue, setTabValue } = useQueryTab("tab", 0);
    const [tools, setTools] = useState<LoanedToolsForMe[]>([]);
    const [myFilteredTools, setFilteredTools] = useState<LoanedToolsForMe[]>([]);
    const [validCert, setValidCert] = useState<CertificateData>();
    const [myCrew, setMyCrew] = useState(Array<MxiStaffManagementEmployee>);
    const [flights, setFlights] = useState(Array<FlightSchedule>());
    const [myFilteredFlights, setMyFilteredFlights] = useState(Array<FlightSchedule>());
    const [myLineTasks, setMyLineTasks] = useState<MyLineTask[]>([]);
    const [lineTasksLoaded, setLineTasksLoadding] = useState<Boolean>(true);
    const [allTails, setAllTails] = useState<Array<string>>([]);
    const [hangarTailFilter, setHangarTailFilter] = useState<string>("");
    const [tarmacTailFilter, setTarmacTailFilter] = useState<string>("");

    const store = useSelector((state: RootState) => state);
    const isTeamLeadViewer = (store.user.me?.user_clearence_groups?.includes("Team Lead View") || store.user.me?.user_clearence_groups?.includes("Team Lead Edit")) || false;    
    const currentUserId = store.user.me.user_id;
    const tabNames = [
        "LM Hangar Tasks",
        "LM Tarmac Tasks",
        "My tools",
        "Certificates",
        "Flight schedule",
        ...(isTeamLeadViewer ? ["Maintenance Operations Teams"] : [])
    ];

    useEffect(() => {
        getCertificates();
        getTools();
        getTasks();
        getFlightSchedule();
        getMyCrew();
        getAllTails();
    }, []);

    const getAllTails = () => {
        taskApi.GetAllTailNumbers().then(res => {
            setAllTails(res.data);
        });
    }

    const getMyCrew = () => {
        staffmanagementApi.GetAllMembersFromMyCrew().then(res => {
            if (res.status) {
                setMyCrew(res.data);
            }
        });
    }
    const getCertificates = () => {
        certificatesApi.GetCertificateForMe().then(res => {
            setValidCert(res.data);
            if (currentUserId !== undefined) {
                certificatesApi.GetCertificateStatus(currentUserId).then(statusRes => {
                    if (statusRes.status) {
                        setValidCert(prev => prev === undefined ? prev : {
                            ...prev,
                            certificate_expired_date_text: statusRes.data.certificate_expired_date_text,
                            expired_date_status: statusRes.data.expired_date_status,
                        });
                    }
                });
            }
        });
    }
    const getTools = () => {
        toolApi.GetToolsForMe().then(res => {
            if(res.data !== undefined && res.data.length > 0) {
                const filteredTools = res.data?.filter(tool => {
                    return tool.returned_date === null;
                });
                setFilteredTools(filteredTools);
                setTools(res.data);
            }
        });
    }

    const getTasks = () => {
        setLineTasksLoadding(true);
        taskApi.GetLineTasksForMe().then(res => {
            if (res.status === true) {
                setMyLineTasks(res.data);
            }
            setLineTasksLoadding(false);
        });
    }

    const getFlightSchedule = () => {
        lineApi.getFlightSchedule().then(res => {
            const filteredFlights = res.data.filter(flight => {
                return flight.assigned_mechanics.find(item => item.user_id === currentUserId)
            });
            setMyFilteredFlights(filteredFlights);
            setFlights(res.data);
        });
    }

    return (
        <div>
            <Tabs
                tabNames={tabNames}
                onChangeTabValue={(tabValue: number) => setTabValue(tabValue)}
                tabValue={tabValue}
            />
            {tabValue === 0 && <MyTaskPlan myCrew={myCrew} allTails={allTails} tailFilter={hangarTailFilter} onTailFilterChange={setHangarTailFilter} />}
            {(tabValue === 1 && myLineTasks !== undefined) && <LineTasks myLineTasks={myLineTasks} loading={lineTasksLoaded} allTails={allTails} tailFilter={tarmacTailFilter} onTailFilterChange={setTarmacTailFilter} />}
            {tabValue === 2 && <MyTools tools={tools} filteredTools={myFilteredTools}/>}
            {(tabValue === 3 && validCert !== undefined) && <MyCertificates validCert={validCert} />}
            {tabValue === 4 && <MyFlightSchedule flights={flights} myFilteredFlights={myFilteredFlights} />}
            {(tabValue === 5 && isTeamLeadViewer) && <TeamsPage />}
        </div>
    )
}

export default MyProfilePage;